import React, { useState } from "react";
import NewCommonServiceContent from "../../../common/NewCommonServices/NewCommonServiceContent";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import work1 from "../../../../assets/images/serviceImages/websiteWork1.webp";
import work2 from "../../../../assets/images/serviceImages/websiteWork2.webp";
import work3 from "../../../../assets/images/serviceImages/websiteWork3.webp";
import work4 from "../../../../assets/images/serviceImages/websiteWork4.webp";
import work5 from "../../../../assets/images/serviceImages/websiteWork5.webp";
import ServiceButton from "../../../common/ServiceButton";

type WorkTypes = {
  image: string;
  href: string;
};

type ButtonType = "UI/UX Design";

const items: WorkTypes[] = [
  {
    image: work1,
    href: "",
  },
  {
    image: work2,
    href: "",
  },
  {
    image: work3,
    href: "",
  },
  {
    image: work4,
    href: "",
  },
  {
    image: work5,
    href: "",
  },
];
const UiUxDesigninhWork = () => {
  const [selectedButton, setSelectedButton] =
    useState<ButtonType>("UI/UX Design");
  return (
    <div>
      <NewCommonServiceContent>
        <div>
          <div className="flex justify-center gap-10 mb-5 sm:mb-10">
            <ServiceButton
              className={`${
                selectedButton === "UI/UX Design" ? "!card-gradient" : ""
              } text-white`}
              onClick={() => setSelectedButton("UI/UX Design")}
            >
              Graphic Design
            </ServiceButton>
          </div>
          <div className="w-full rounded-[16px] overflow-hidden h-[300px] sm:h-auto">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              className="flex justify-center items-center"
              pagination={{
                type: "bullets",
                el: ".pagination-progress",
                clickable: true,
              }}
              autoplay={true}
              spaceBetween={20}
              slidesPerView={1}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              loop
            >
              {" "}
              {items.map((item, index) => (
                <SwiperSlide
                  className={`!flex justify-center rounded-[16px] overflow-hidden`}
                  key={index}
                >
                  <a href={item.href}>
                    <img
                      src={item.image}
                      alt=""
                      className="w-full rounded-[16px] h-[280px] object-cover object-left sm:h-auto"
                    />
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="swiper-pagination pagination-progress"></div>
          </div>
        </div>
      </NewCommonServiceContent>
    </div>
  );
};

export default UiUxDesigninhWork;
